<div class="dropdown-input">
  <select (change)="setOption($event)" [value]="default">
    <option *ngFor="let option of options" [value]="option" [selected]="option === default">{{ option }}</option>
  </select>
</div>
